<template>
  <div>
    <interview-route-change-modal :show-route-change-modal="showRouteChangeModal" @leavePage="routerNext()"
      @stayPage="showRouteChangeModal = false" />
    <interview-candidate-header :interview="interview" :candidate="interviewCandidateInfo.candidate" :tab="getTabIndex" />
    <div class="page-view">
      <b-container class="p-0">
        <vue-content-loading v-show="loading" :height="59" :speed="1">
          <rect x="0" y="10" rx="4" ry="4" width="100%" height="75" />
        </vue-content-loading>
        <div v-if="!loading">
          <validation-observer ref="observer" v-slot="{ invalid }">
            <b-container class="p-0 mb-4">
              <b-row class="m-0">
                <b-col cols lg="12">
                  <b-row>
                    <b-col class="px-0 py-2">
                      <h3>{{ interviewCandidateInfo.interviewCandidateLog.interviewName }}</h3>
                    </b-col>
                  </b-row>
                  <!-- item start -->
                  <b-row v-for="(item) in interviewAnswers.data" :key="item.interviewQuestionId" class="question-item">
                    <b-col lg="12" class="p-0">
                      <h3>{{ `${item.order}. ${resource['question']}` }}</h3>
                    </b-col>
                    <b-col lg="12">
                      <b-row class="mb-4">
                        <b-col class="p-0">
                          <validate-form :id="`questionTitle`" v-model="item.questionTitle" type="text" :disabled="true"
                            :name='resource["question"]'>
                          </validate-form>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="p-0">
                          <validation-observer ref="observer" v-slot="{ validate }">
                            <validate-form id="1" v-model="item.videoPath" which-component="b-form-textarea" name="answer"
                              placeholder="Örn: Lorem ipsum dolor sit amet" label-form="Answer" rows="5" rules="max:500"
                              :disabled="tabIndex === 1" @input="checkValidate(validate)" no-resize />
                          </validation-observer>
                        </b-col>
                      </b-row>
                    </b-col>
                    <p class="text-right w-100">{{ item.videoPath?.length || 0 }}/500</p>
                  </b-row>
                  <!-- item end -->
                  <b-row class="justify-content-end">
                    <step-pagination :isDisable="invalid" v-show="isShowPagination" :step-total="interviewAnswers.total"
                      :step-data-count="interviewAnswers.perPage" :current-page-index="interviewAnswers.page"
                      @currentIndex="changePaginationIndex" />
                  </b-row>
                </b-col>
              </b-row>
            </b-container>
          </validation-observer>
        </div>
      </b-container>
      <div class="text-action-button">
        <button v-if="!invalid && !buttonLoading" id="nextStepButton" name="nextStepButton" class="btn lg bg-purple text-white"
          :disabled="invalid" @click="!invalid ? checkAction() : {}
          " style="border-radius: 40px;">
          {{ resource['label.Save'] }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import tocList from '@/components/hrVenue/interviewCreateEdit/mixins/tocList';
import { showNotification } from '@/static/helpers';
import hrvenueService from '../../../services/hrvenue.service';

export default {
  name: 'interviewCandidateTextDetail',

  mixins: [tocList],
  components: {
    InterviewCandidateHeader: () => import('./interviewCandidateHeader.vue'),
    InterviewRouteChangeModal: () => import('./interviewCandidateRouteChangeModal.vue'),
    StepPagination: () => import('../../layout/StepPagination.vue'),
  },

  props: {
    interviewCandidateInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      tabIndex: 0,
      interviewCandidate: {},
      showRouteChangeModal: false,
      routerNext: null,
      interviewAnswers: [],
      layout: {
        isSubmit: false,
        tocList: [],
      },
      oldAnswers: '',
      buttonLoading: false,

      interview: {},
    };
  },

  async created() {
    this.loading = true;

    try {
      await this.getData();
    } catch (error) {
      showNotification(
        this.resource['Label.Warning'],
        this.resource['candidateDetail.interviewCannotAccessWarning'],
        'warning',
      );
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      return this.$router.push({
        name: 'HrVenueView',
        params: {
          lang,
        },
      });
    }

    this.loading = false;
  },

  mounted() {
    this.layout.tocList = [
      {
        title: this.resource['hrvenue.candidateAnswers'],
        key: 'answers',
        class: 'active',
      },
      {
        title: this.resource['hrvenue.menuPreview'],
        key: 'preview',
        class: '',
      },
    ];
  },

  computed: {
    interviewCandidateLogId() {
      return this.$route.params.interviewCandidateLogId;
    },

    getTabIndex() {
      return this.$route.params.tab;
    },

    isShowPagination() {
      return !this.loading;
    },

    uit() {
      return this.$route.query.uit;
    },
  },

  methods: {
    async getData() {
      this.interview = {
        interviewId: this.interviewCandidateInfo?.interviewCandidateLog?.interviewId,
        interviewName: this.interviewCandidateInfo?.interviewCandidateLog?.interviewName,
        interviewCandidateStatusId: this.interviewCandidateInfo?.interviewCandidateLog?.interviewCandidateStatusId,
      };

      // düzenle
      this.oldAnswers = JSON.parse(JSON.stringify(this.interviewCandidateInfo.interviewCandidateAnswers));
      this.interviewAnswers = this.paginator(this.interviewCandidateInfo.interviewCandidateAnswers, 1, 20);

      this.type = this.interviewCandidateInfo.interviewCandidateLog.interviewType || this.$route.params.type;
    },

    paginator(items, currentPage, perPageItems) {
      const page = currentPage || 1;
      const perPage = perPageItems || 10;
      const offset = (page - 1) * perPage;

      const paginatedItems = items.slice(offset).slice(0, perPageItems);
      const totalPages = Math.ceil(items.length / perPage);

      return {
        page,
        perPage,
        pre_page: page - 1 ? page - 1 : null,
        next_page: (totalPages > page) ? page + 1 : null,
        total: items.length,
        totalPages,
        data: paginatedItems,
      };
    },

    checkValidate(validate) {
      validate();
    },

    async saveAnswers() {
      try {
        const { isSuccess } = await hrvenueService.saveInterviewAnswer(
          this.interviewCandidateInfo.interviewCandidateLog.id,
          this.interviewCandidateInfo.interviewCandidateLog.interviewCandidateId,
          this.interviewCandidateInfo.interviewCandidateAnswers.map((item) => ({
            ...item,
            answer: item.videoPath,
          })),
        );
        if (!isSuccess) {
          showNotification(
            this.resource['label.Error'],
            this.resource['candidateDetail.interviewAnswerSaveError'],
            'error',
          );

          return;
        }
        showNotification(
          this.resource['label.Success'],
          this.resource['candidateDetail.interviewAnswerSaveSuccess'],
          'success',
        );
        this.$emit('changeAnswerStatus', false);
        const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

        return this.$router.push({
          name: 'InterviewDetailView',
          params: {
            interviewId: this.interview.interviewId,
            lang,
          },
        });
      } catch (error) {
        //
      }
      this.$emit('changeAnswerStatus', false);
    },

    async checkAction() {
      this.buttonLoading = true;
      this.saveAnswers();
    },

    async changePaginationIndex(newIndex) {
      this.loading = true;
      this.interviewAnswers = this.paginator(this.interviewCandidate.interviewAnswers, newIndex, 4);
      this.loading = false;
    },
  },
  watch: {
    interviewCandidate: { // düzenle
      handler(newVal) {
        if (JSON.stringify(newVal.interviewAnswers) !== JSON.stringify(this.oldAnswers)) {
          this.$emit('changeAnswerStatus', true);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';

.question-item {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--stroke-colors-divider-line, #E4E4E4);
  background: var(--background-colors-white, #FFF);
  margin-bottom: 16px;
}

::v-deep textarea {
  padding: 8px !important;
}

::v-deep .pagination {
  padding: 0 !important;
}

.text-action-button {
  position: fixed;
  bottom: 0;
  width: calc(100% - 250px);
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  align-items: flex-start;
  gap: var(--Padding-Large, 16px);
  align-self: stretch;
  border-top: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
  background: var(--background-colors-white, #FFF);
}
</style>
